module.exports = __webpack_public_path__ + "static/media/entrance-exams.74d48a57.svg";